<div [ngClass]="getDatePickerValues == false ? 'filter-calendar-container' : 'filter-container'" *ngIf="status === 'success'" [@fadeInOut]>
  <ng-content></ng-content>
</div>
